import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import React, { useCallback, useState } from 'react'
import { SubmitHandler } from 'react-hook-form'

import { useUpdateCannedJobDate } from '../../../hooks'
import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import {
  useCreateCannedJobPartLookupMutation,
  useUpdateCannedJobPartLookupMutation
} from '../../../redux/api/cannedJobApi'
import { CannedJobPartLookupEntry, CannedJobPartLookupInfo } from '../../../sdk'
import { CannedJobPartLookupForm } from './CannedJobPartLookupForm'

export const useAddPartLookupDialog = () => {
  const { accessToken } = useAccessTokenAndShopId()

  const [createPartLookup] = useCreateCannedJobPartLookupMutation()
  const [updatePartLookup] = useUpdateCannedJobPartLookupMutation()
  const [customProps, setCustomProps] = useState<
    | {
        cannedJobId: string
        existingEntry: CannedJobPartLookupEntry | undefined
      }
    | undefined
  >()
  const { cannedJob, updateDate } = useUpdateCannedJobDate()
  const handleClose = useCallback(() => {
    setCustomProps(undefined)
  }, [])
  const onSubmit: SubmitHandler<CannedJobPartLookupInfo> = useCallback(
    async (data) => {
      if (!customProps || !cannedJob) {
        return
      }
      if (customProps.existingEntry) {
        updatePartLookup({
          authorization: accessToken,
          cannedJobPartLookupEntry: {
            id: customProps.existingEntry.id!,
            info: {
              ...data,
              cannedJob: cannedJob.entry!.id!
            }
          }
        })
      } else {
        createPartLookup({
          authorization: accessToken,
          cannedJobPartLookupInfo: {
            ...data,
            cannedJob: cannedJob.entry!.id!
          }
        })
      }
      updateDate()
      handleClose()
    },
    [
      customProps,
      cannedJob,
      updateDate,
      handleClose,
      updatePartLookup,
      accessToken,
      createPartLookup
    ]
  )
  const AddPartLookupDialog = useCallback(() => {
    return (
      <>
        {customProps && (
          <Dialog open={true} fullWidth={true} maxWidth={'xs'}>
            <DialogTitle data-testid="dialogTitle">Add part lookup</DialogTitle>
            <DialogContent>
              <CannedJobPartLookupForm
                formId={'addCannedJobParkLookupForm'}
                onSubmit={onSubmit}
                defaultValues={customProps.existingEntry?.info!}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleClose()}>Cancel</Button>
              <Button
                variant="contained"
                type="submit"
                data-testid="saveLaborOverride"
                form="addCannedJobParkLookupForm">
                Save
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </>
    )
  }, [customProps, handleClose, onSubmit])
  return {
    setCustomProps,
    AddPartLookupDialog
  }
}
